/* Collections Slider */

var swiper = new Swiper(".collectionsSwiper", {
      slidesPerView: 2,
      spaceBetween: 16,
      rewind: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1271: {
          slidesPerView: 5,
          spaceBetween: 32,
        },
      },
    });

/* Products Slider */
var swiper = new Swiper(".productsSwiper", {
      slidesPerView: 2,
      spaceBetween: 16,
      rewind: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1271: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
    });

/* Blog Slider */
var swiper = new Swiper(".blogSwiper", {
      slidesPerView: 1,
      spaceBetween: 16,
      rewind: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        769: {
          slidesPerView: 3,
          spaceBetween: 24,
        },
        1271: {
          slidesPerView: 4,
          spaceBetween: 32,
        },
      },
    });

/* Product Images Slider */
document.addEventListener('DOMContentLoaded', function () {
  var galleryThumbs = new Swiper('.gallery-thumbs', {
    centeredSlides: true,
    centeredSlidesBounds: true, 
    direction: 'horizontal',
    spaceBetween: 10,
    slidesPerView: 5,
    freeMode: false,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    watchOverflow: true,
    breakpoints: {
      1300: {
        direction: 'vertical',
        slidesPerView: 6,
      }
    }
  });

  var galleryTop = new Swiper('.gallery-top', {
    direction: 'horizontal',
    spaceBetween: 0,
    a11y: {
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
    keyboard: {
      enabled: true,
    },
    thumbs: {
      swiper: galleryThumbs
    },
    watchSlidesVisibility: true,
    watchSlidesProgress: true
  });
 // Synchronize the two sliders
  galleryTop.on('slideChange', function () {
    var currentIndex = galleryTop.activeIndex;
    galleryThumbs.slideTo(currentIndex, 300);  // Synchronize with animation
  });

  galleryThumbs.on('slideChange', function () {
    var currentIndex = galleryThumbs.activeIndex;
    galleryTop.slideTo(currentIndex, 300);  // Synchronize with animation
  });
  
});

/* Buy it with Swiper */
var swiper = new Swiper(".buyItWithSwiper", {
      slidesPerView: 1,
      spaceBetween: 16,
      autoHeight: true,
      rewind: true,
      pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
  breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
        1271: {
          slidesPerView: 1,
          spaceBetween: 16,
        },
      },
    });

